import Controller from '@ember/controller';
import { cached } from '@glimmer/tracking';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import Store from '@ember-data/store';
import Settings from 'donor-elf-web/services/settings';
import type { DashboardRouteModel } from 'donor-elf-web/routes/funds/fund/dashboard';
import CurrentUser from 'donor-elf-web/services/current-user';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import FundsService from 'donor-elf-web/services/funds-service';
import CampaignService from 'donor-elf-web/services/campaign-service';

export default class DashboardController extends Controller {
  @service declare abilities: AbilitiesService;
  @service declare campaignService: CampaignService;
  @service declare currentUser: CurrentUser;
  @service declare contactsCache: ContactsCache;
  @service declare fundsService: FundsService;
  @service declare settings: Settings;
  @service declare store: Store;

  model!: DashboardRouteModel;

  @cached
  get showAssignedTasks() {
    return this.abilities.hasAbility('assign_tasks');
  }

  get userStripeIsDelinquent() {
    return this.currentUser.stripeIsDelinquent;
  }

  markAllEventsRead = () => {
    this.model.dashboard.unreadEvents = [];
    let markRead = this.store.createRecord('mark-all-events-read', {
      fund_id: 1,
    });
    markRead.save();
  };
}
